import { Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import EventAttachmentModal from '@/components/EventAttachmentModal';
import { EVENT_MODE_MAP, EVENT_TYPE_MAP } from '@/services/event';
import { getResourceUrl } from '@/utils';

import styles from './index.less';

const { Text } = Typography;

export function EventCard({
  data,
}: {
  data: API.RobotMqttResponse<API.EVENT.Event>;
}) {
  const [eventAttachmentModal, setEventAttachmentModal] = useState<{
    open: boolean;
    event?: API.EVENT.Event;
  }>({ open: false });

  console.log('[Event Card]', data);
  const event = data.payload;
  const { color: typeColor, label: typeLabel } =
    EVENT_TYPE_MAP[event.eventType] || {};
  const { label: modeLabel } = EVENT_MODE_MAP[event.eventMode] || {};

  const onShowDetail = (event: API.EVENT.Event) => {
    setEventAttachmentModal({
      open: true,
      event,
    });
  };

  return (
    <div className={styles.cardContainer} style={{ width: 400 }}>
      <div className={styles.header}>
        <Text type="secondary">
          {event.attachment ? '拍照' : '事件'}时间：{' '}
          {dayjs.unix(data.timestamp).format('YYYY-MM-DD HH:mm:ss')}
        </Text>
      </div>
      <div className={styles.title}>
        {modeLabel ? (
          <Tag bordered={false} color={typeColor}>
            {modeLabel}：{typeLabel}
          </Tag>
        ) : null}
        <Text>{event.alertContent}</Text>
      </div>
      <div className={styles.picture}>
        {event.attachment ? (
          <img
            src={getResourceUrl(event.attachment)}
            alt="attachment"
            onClick={() => onShowDetail(event)}
          />
        ) : null}
      </div>
      <EventAttachmentModal
        {...eventAttachmentModal}
        onClose={() => setEventAttachmentModal({ open: false })}
      />
    </div>
  );
}
